import { cn } from "@/lib/utils";
import { Link } from "@inertiajs/react";
import { ArrowLeftIcon } from "lucide-react";
import { buttonVariants } from "./ui/button";

export default function BackToDashboard() {
  return (
    <div className="-ml-4">
      <Link href="/dashboard" className={cn(buttonVariants({ variant: "ghost" }))}>
        <ArrowLeftIcon className="w-4 h-4" /> Dashboard
      </Link>
    </div>
  );
}
